import {useUpmPlantContext, useUpmPlantTimezone} from '@hconnect/upm'

import {
  SlaCommentsContentContainer,
  SlaCommentsDatePicker,
  SlaCommentsFilters,
  SlaCommentsModalView
} from '../components'
import {useSlaCommentsModalState} from '../hooks'

import {SlaKpiCommentsVersionsContainer} from './SlaKpiCommentsVersionsContainer'

type SlaCommentsModalContainerProps = {
  onClose: () => void
  year: number
}

export const SlaCommentsModalContainer = ({onClose, year}: SlaCommentsModalContainerProps) => {
  const {upmId: plantUpmId} = useUpmPlantContext()
  const timezone = useUpmPlantTimezone()
  const {
    control,
    roleOptions,
    kpiOptions,
    displayItems,
    isCommentsLoading,
    isCommentsError,
    selectedComment,
    handleOpenVersions,
    handleCloseVersions,
    t
  } = useSlaCommentsModalState({plantUpmId, year, timezone})

  return (
    <>
      <SlaCommentsModalView
        open
        onClose={onClose}
        title={t('commentsModal.title')}
        disableFocusManagement={Boolean(selectedComment)}
      >
        <SlaCommentsFilters
          control={control}
          searchLabel={t('commentsModal.searchPlaceholder')}
          roleLabel={t('commentsModal.roleLabel')}
          kpiLabel={t('commentsModal.kpiLabel')}
          roleOptions={roleOptions}
          kpiOptions={kpiOptions}
        />
        <SlaCommentsDatePicker control={control} label={t('commentsModal.dateLabel')} />
        <SlaCommentsContentContainer
          isLoading={isCommentsLoading}
          isError={isCommentsError}
          items={displayItems}
          emptyMessage={t('commentsModal.empty')}
          errorMessage={t('comments.message.failedToFetchComments')}
          onOpenVersions={handleOpenVersions}
        />
      </SlaCommentsModalView>
      {selectedComment && (
        <SlaKpiCommentsVersionsContainer
          isOpen
          onClose={handleCloseVersions}
          kpiName={selectedComment.kpiName}
          kpiUnit={selectedComment.kpiUnit}
          kpiValueId={selectedComment.kpiValueId}
        />
      )}
    </>
  )
}
